import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const BuildIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"build"} ref={ref}/>
});

BuildIcon.displayName = "BuildIcon";
